/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendCapexVariantDto } from '../../models/backend-capex-variant-dto';
import { BackendCapexVariantRequestDto } from '../../models/backend-capex-variant-request-dto';

export interface EconomicIndicatorsCapexVariantsCreate$FormData$Params {
  body: BackendCapexVariantRequestDto;
}

export function economicIndicatorsCapexVariantsCreate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: EconomicIndicatorsCapexVariantsCreate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendCapexVariantDto>> {
  const rb = new RequestBuilder(rootUrl, economicIndicatorsCapexVariantsCreate$FormData.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendCapexVariantDto>;
    }),
  );
}

economicIndicatorsCapexVariantsCreate$FormData.PATH = '/api/economic_indicators/capex_variants/';
